import { sagas as login } from "../../../forms/Login";
import { sagas as smsVerification } from "../../../forms/SmsVerification";
import reservation from "./reservation";
import paymentAuthorization from "./paymentAuthorization";

export default [
  ...login,
  ...smsVerification,
  ...paymentAuthorization,
  ...reservation,
];
